import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.section`
    color: ${vars.colorPrimary};

    .content-wrapper {
        margin-top: 5em;
        margin-bottom: 6em;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        gap: 1em;

        .icon-wrapper {
            margin: 0 0 1em 0;
        }

        .message-sent-header {
            font-size: 3em;
        }

        .button {
            max-width: 25em;
            margin-top: 0.5em;
        }
    }
`;
